import React from 'react';
//import CateringSettingContent from '../Components/CateringSettingContent';
import CateringSettingContext from '../CateringSettingContext';
import useCateringSetting from '../useCateringSetting';
import CateringSettingsContent from '../Components/CateringSettingsContent';

const CateringSettingRoot = () => {
    const cateringSettingHook = useCateringSetting();
    return (
        <CateringSettingContext.Provider value={cateringSettingHook}>
            <CateringSettingsContent />
        </CateringSettingContext.Provider>
    );
};

export default CateringSettingRoot;
